<template>
  <router-view>
    <v-container fluid grid-list-xl>
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-layout row wrap>
          <v-flex xs12 sm6 d-flex>
            <v-select
              v-model="fields.tip_client.value"
              :items="form.items.tipuriClient"
              :rules="form.rules.tip_client"
              :hint="fields.tip_client.value !== undefined ? fields.tip_client.value.hint : ''"
              item-text="label"
              item-value="type"
              :label="form.lang.tip_client_label"
              validate-on-blur return-object box dense required
            ></v-select>
          </v-flex>
          <v-flex xs12 sm6 d-flex>
            <v-select
              v-model="fields.tip_oferta.value"
              :items="form.items.tipuriOferte"
              :rules="form.rules.tip_oferta"
              :hint="fields.tip_oferta.value !== undefined ? fields.tip_oferta.value.hint : ''"
              item-text="label"
              item-value="type"
              :label="form.lang.tip_oferta_label"
              validate-on-blur return-object box dense required
            ></v-select>
          </v-flex>
          <v-flex xs12 sm6 d-flex>
            <v-text-field
              v-model="fields.consum_lunar.value"
              :rules="form.rules.consum_lunar"
              :label="form.lang.consum_lunar_label"
              validate-on-blur type="tel" step="1" suffix="kWh" box dense required
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm6 d-flex>
            <v-select
              v-model="fields.nivel_tensiune.value"
              :items="form.items.niveluriTensiuni"
              :rules="form.rules.nivel_tensiune"
              :label="form.lang.nivel_tensiune_label"
              item-text="label"
              item-value="value"
              validate-on-blur return-object box dense required
            ></v-select>
          </v-flex>
          <v-flex xs12 sm6 d-flex>
            <v-select
              v-model="fields.tip_pret.value"
              :items="form.items.tipuriPreturi"
              :rules="form.rules.tip_pret_oferta"
              :label="form.lang.tip_pret_oferta_label"
              item-text="label"
              item-value="value"
              validate-on-blur return-object box dense required
            ></v-select>
          </v-flex>
          <v-flex xs12 sm6>
            <v-menu
              v-model="menu"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="fields.data_start_aplicare.value"
                  v-bind="attrs"
                  v-on="on"
                  :label="form.lang.data_start_aplicare_label"
                  :rules="form.rules.data_start_aplicare"
                  readonly box dense required
                />
              </template>
              <v-date-picker
                v-model="fields.data_start_aplicare.value"
                @input="menu = false"
              />
            </v-menu>
          </v-flex>
          <v-flex xs12 sm6 d-flex>
            <v-select
              v-model="fields.id_judet.value"
              :items="fields.id_judet.items"
              :rules="form.rules.id_judet"
              :loading="fields.id_judet.loading"
              item-text="nume"
              item-value="id_judet"
              :label="form.lang.judet_label"
              validate-on-blur return-object box dense required
            ></v-select>
          </v-flex>
          <v-flex xs12 sm6 d-flex>
            <v-text-field
              v-model="fields.valoare_factura_curenta.value"
              :rules="form.rules.valoare_factura_curenta"
              :label="form.lang.valoare_factura_curenta_label"
              validate-on-blur type="tel" step="1" box dense required
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm6 d-flex>
            <v-select
              v-model="fields.valoare_fixa.value"
              :items="form.items.valoareFixa"
              :rules="form.rules.valoare_fixa"
              :label="form.lang.valoare_fixa_label"
              item-text="label"
              item-value="value"
              validate-on-blur return-object box dense
            ></v-select>
          </v-flex>
          <v-flex xs12 sm6 d-flex>
            <v-select
              v-model="fields.tip_produs.value"
              :items="form.items.tipuriProdus"
              :rules="form.rules.tip_produs"
              :label="form.lang.tip_produs_label"
              item-text="label"
              item-value="type"
              validate-on-blur return-object box dense required
            ></v-select>
          </v-flex>
          <transition>
            <v-flex v-if="fields.tip_pret.value !== undefined && fields.tip_pret.value.value === 2" xs12 sm6 d-flex>
              <v-layout row>
                <v-flex xs3 md1>
                  <v-text-field
                    :value="fields.pret_oferta_diferentiat_zi.value + '%'"
                    :label="form.lang.zi_label"
                    readonly
                    disabled
                    dense
                  ></v-text-field>
                </v-flex>
                <v-flex xs6 md10>
                  <v-slider
                    v-model="fields.pret_oferta_diferentiat_zi.value"
                    :max="fields.pret_oferta_diferentiat_zi.max"
                    :rules="form.rules.pret_oferta_diferentiat_zi"
                  ></v-slider>
                </v-flex>
                <v-flex xs3 md1>
                  <v-text-field
                    :value="100 - fields.pret_oferta_diferentiat_zi.value + '%'"
                    :label="form.lang.noapte_label"
                    readonly
                    disabled
                    dense
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-flex>
          </transition>
          <v-flex xs12 d-flex>
            <h3>Criterii suplimentare de selectie</h3>
          </v-flex>
          <v-flex xs12 sm6 d-flex>
            <v-select
              v-model="fields.factura_electronica.value"
              :items="form.items.facturaElectronica"
              :rules="form.rules.factura_electronica"
              :label="form.lang.factura_electronica_label"
              item-text="label"
              item-value="value"
              validate-on-blur return-object box dense required
            ></v-select>
          </v-flex>
          <v-flex xs12 sm6 d-flex>
            <v-select
              v-model="fields.frecventa_citire_contor.value"
              :items="form.items.frecventeCitireContor"
              :rules="form.rules.frecventa_citire_contor"
              :label="form.lang.frecventa_citire_contor_label"
              item-text="label"
              item-value="value"
              validate-on-blur return-object box dense
            ></v-select>
          </v-flex>
          <v-flex xs12 sm6 d-flex>
            <v-select
              v-model="fields.energie_regenerabila.value"
              :items="form.items.energieRegenerabila"
              :rules="form.rules.energie_regenerabila"
              :label="form.lang.energie_sursa_regenerabile_label"
              item-text="label"
              item-value="value"
              validate-on-blur return-object box dense
            ></v-select>
          </v-flex>
          <v-flex xs12 sm6 d-flex>
            <v-select
              v-model="fields.frecventa_emitere_factura.value"
              :items="form.items.frecventeEmitereFacturi"
              :rules="form.rules.frecventa_emitere_factura"
              :label="form.lang.frecventa_emitere_factura_label"
              item-text="label"
              item-value="value"
              validate-on-blur return-object box dense
            ></v-select>
          </v-flex>
          <v-flex xs12 sm6 d-flex>
            <v-select
              v-model="fields.perioada_contract.value"
              :items="form.items.perioadeContract"
              :rules="form.rules.perioada_contract"
              :label="form.lang.perioada_contract_label"
              item-text="label"
              item-value="value"
              validate-on-blur return-object box dense
            ></v-select>
          </v-flex>
        </v-layout>
        <p class="text-xs-center">
          <v-btn color="primary" type="submit" @click.prevent="submit">{{ form.lang.compara_preturi_label }}</v-btn>
        </p>
      </v-form>
    </v-container>
  </router-view>
</template>
<script>
  import {mapGetters} from 'vuex';
  import {makeQuery} from "@/modules/common.js";
  import loadJudete from '@/modules/electric/judete.js';
  import makeForm from '@/modules/electric/form.js'
  import moment from "moment";

  export default {
    data: function () {
      return {
        valid: true,
        menu: false,
        fields: {
          tip_client: {
            serialize: item => item.type,
            value: undefined
          },
          tip_oferta: {
            serialize: item => item.type,
            value: undefined
          },
          consum_lunar: {
            value: ""
          },
          id_judet: {
            items: [],
            loading: false,
            serialize: item => item.id_judet,
            value: undefined
          },
          id_zona: {
            value: undefined
          },
          data_start_aplicare: {
            value: ""
          },
          tip_produs: {
            serialize: item => item.type,
            value: undefined
          },
          valoare_fixa: {
            serialize: item => item.value,
            value: undefined
          },
          valoare_factura_curenta: {
            value: ""
          },
          nivel_tensiune: {
            serialize: item => item.value,
            value: undefined
          },
          tip_pret: {
            serialize: item => item.value,
            value: undefined
          },
          pret_oferta_diferentiat_zi: {
            value: 50,
            max: 100
          },
          factura_electronica: {
            serialize: item => item !== undefined ? item.value : undefined,
            value: undefined
          },
          frecventa_emitere_factura: {
            serialize: item => item !== undefined ? item.value : undefined,
            value: undefined
          },
          frecventa_citire_contor: {
            serialize: item => item !== undefined ? item.value : undefined,
            value: undefined
          },
          perioada_contract: {
            serialize: item => item !== undefined ? item.value : undefined,
            value: undefined
          },
          energie_regenerabila: {
            serialize: item => item !== undefined ? item.value : undefined,
            value: undefined
          }
        }
      }
    },
    computed: {
      ...mapGetters(['language']),
      form() {
        return makeForm(this.language);
      }
    },
    methods: {
      loadJudete() {
        this.fields.id_judet.loading = true;
        return loadJudete(this.language)
          .then(response => response.json())
          .then(body => {
            this.fields.id_judet.items = body.data;
          })
          .catch(e => {
            console.log(e);
          })
          .then(() => {
            this.fields.id_judet.loading = false;
          })
      },
      submit() {
        if (!this.$refs.form.validate()) {
          return;
        }
        const query = makeQuery({
          ...this.fields,
          id_zona: {
            value: this.fields.id_judet.value.id_zona
          }
        });

        this.$router.push({
          name: 'electric.results',
          query
        });
      }
    },
    mounted() {
      this.loadJudete();
      this.$watch('form', (v) => {
        if (v) {
          this.fields.tip_client.value = v.items.tipuriClient[0];
          this.fields.tip_oferta.value = v.items.tipuriOferte[0];
          this.fields.data_start_aplicare.value = moment().format('YYYY-MM-DD');
          this.fields.consum_lunar.value = '100';
          this.fields.nivel_tensiune.value = v.items.niveluriTensiuni[1];
          this.fields.tip_pret.value = v.items.tipuriPreturi[0];
          this.fields.tip_produs.value = v.items.tipuriProdus[0];
          this.fields.valoare_fixa.value = v.items.valoareFixa[0];
          this.fields.factura_electronica.value = v.items.facturaElectronica[0];
          this.fields.frecventa_emitere_factura.value = v.items.frecventeEmitereFacturi[0];
          this.fields.frecventa_citire_contor.value = v.items.frecventeCitireContor[0];
          this.fields.perioada_contract.value = v.items.perioadeContract[0];
          this.fields.energie_regenerabila.value = v.items.energieRegenerabila[0];
        }
      }, { immediate: true });
    }
  }
</script>
